import { useEffect, useMemo, useState } from "react";
import { useElementSize } from "usehooks-ts";
import LineChart from "./lineChart";
import Widget from "../../../baseWidget";
import { useWidgetContext } from "../../../../helpers/hooks/useWidgetContext";
import { useDispatch, useSelector } from "react-redux";
import { addWidgetToFilterList } from "../../../../state/features/analytics/actions";
import { RootState } from "../../../../state/store";

const LineChartSimple = () => {
  const [widgetData, setWidgetData] = useState<any>();
  const [widgetRef, contentDimensions] = useElementSize();

  const widget = useWidgetContext();
  const dispatch = useDispatch();

  const { widgets: widgetFilters } = useSelector(
    (state: RootState) => state.filters
  );

  const widgetHasData = useMemo(() => {
    if (widget.widgetData.data && widget.widgetData.data.length > 0) {
      return true;
    }
    return false;
  }, [JSON.stringify(widgetData)]);

  useEffect(() => {
    if (widget.widgetData.data && widget.widgetData.data.length > 0) {
      setWidgetData(widget.widgetData);
      const widgetFilterExists = widgetFilters.find(
        (i: any) => i.key == widget?.widgetFilterConfig?.widgetFilterKey
      );
      if (widget?.widgetFilterConfig?.enableFilters && !widgetFilterExists) {
        let filterConfig = {
          name: widget.widgetFilterConfig.filterTitle,
          filterKey: widget.widgetFilterConfig.widgetFilterKey,
          options: widget.widgetData.data || [],
        };
        dispatch(addWidgetToFilterList(filterConfig));
      }
    }
  }, [widget.widgetData]);

  return (
    <Widget ref={widgetRef}>
      <Widget.Header>
        <Widget.Title>{widgetData?.title}</Widget.Title>
        <Widget.Controls>
          {widgetHasData ? <Widget.ExtendedAReportCta /> : null}
        </Widget.Controls>
      </Widget.Header>
      <Widget.Content>
        {widgetHasData ? (
          <LineChart
            data={widgetData.data}
            width={contentDimensions.width - 50}
            height={contentDimensions.height - 90}
            config={widgetData.config}
          />
        ) : (
          <Widget.EmptyData
            width={contentDimensions.width - 50}
            height={contentDimensions.height - 90}
          />
        )}
      </Widget.Content>
    </Widget>
  );
};

export default LineChartSimple;

